import React, { createContext, useContext, useState } from 'react';

interface PageContextType {
  title: string;
  setTitle: (title: string) => void;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

export const PageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState('Bookmarks');

  return (
    <PageContext.Provider value={{ title, setTitle }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageTitle = () => {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error('usePageTitle must be used within a PageProvider');
  }
  return context;
};